import * as React from "react";
import classnames from "classnames";
import { Modal } from "@grandvisionhq/common";
/* empty css                */
const PopupModal = ({ className, children, ...rest }) => /* @__PURE__ */ React.createElement(Modal, { ...rest, className: classnames("popup-modal", className) }, children);
export {
  PopupModal,
  PopupModal as default
};
//# sourceMappingURL=PopupModal.js.map
